module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAABAElEQVQokX3SMUpDQRDG8V8eESLWNkEbUbyBeAUJNtYiVlYKpvMGdtFOxEJM0MYuEM/gEWwMVlrYpBCjgsbi7cLLc59fs8vM/Hfn252a0URBCzhEC0shNsQAHTzHwloB3MUZGtL6wB56UC9AlxVAVAPdsO9lWAw3RT1hH6OKA87RzOSeiu3NB3gNDwlwFu0Mm6XEHPrYwjruEnCrZjT5wkxFWzfyBznGQSH+mVUAUd9h/VNXl/tZKcV/cIQL3GKjlB9mcj9Fvcl993GfgGCQ4VT+uVGvWA7QagIaoxMnZwdXiaKUtnEdTXcDPP4HeI8Q07MKTbRND/mjfMhP8BILfwGTbjmD0p6JcAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/spacerBar/img/more.png
// module id = LHyw
// module chunks = 163